<div class="line-w-down-arrow" (click)="closeBottomSheet()">
  <image-loader-utils url="up-arrow" extraClasses="arrow-icon down"></image-loader-utils>
</div>
<ul class="filter-league-list">
  <ng-container *ngFor="let i of leagueData | sortBy : false : 'Rank'; let l = index">
    <li>
      <p class="preIcon iconsCenter paddinglite">
        <mat-checkbox [name]="'ch_' + l" color="primary" [(ngModel)]="leagueData[l].isCheckedByFilter" (ngModelChange)="dataChanged($event, l)">
          <p class="upperText">
            <image-loader-utils [url]="getIso(i.CatId)" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
            {{ i.GroupName?.split('/')[0] }}
          </p>
          <p class="lowerText">{{ i.GroupName?.split('/')[1] }}</p>
        </mat-checkbox>
      </p>
    </li>
  </ng-container>
</ul>
<button style="width: 100%" class="slip-submit gray" (click)="clearAction()" mat-stroked-button>
  <image-loader-utils url="times" extraClasses="times-icon"></image-loader-utils>
  {{ 'clear_filter' | t }}
</button>
